import React, { useState } from "react";

const API_BASE =
  process.env.REACT_APP_API_BASE ||
  (typeof window !== "undefined" && window.location.hostname === "localhost"
    ? "http://127.0.0.1:8000"
    : "");

const PAYSTACK_PUBLIC_KEY =
  process.env.REACT_APP_PAYSTACK_PUBLIC_KEY || "";

const USER_ID = 1;
const ANNUAL_MONTHLY_EQUIVALENT_USD = 39;
const ANNUAL_TOTAL_USD = 468;
const ANNUAL_AMOUNT_CENTS = 46800;

function SubscriptionAnnual() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [status, setStatus] = useState({ type: "", text: "" });

  const verifyPayment = async (reference) => {
    const res = await fetch(`${API_BASE}/payments/verify`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        reference,
        user_id: USER_ID,
      }),
    });

    const data = await res.json().catch(() => ({}));

    if (!res.ok) {
      throw new Error(data?.error || data?.message || "Payment verification failed.");
    }

    return data;
  };

  const handleAnnualCheckout = () => {
    setStatus({ type: "", text: "" });

    if (!PAYSTACK_PUBLIC_KEY) {
      setStatus({
        type: "error",
        text: "Missing Paystack public key.",
      });
      return;
    }

    if (typeof window === "undefined" || !window.PaystackPop) {
      setStatus({
        type: "error",
        text: "Paystack checkout script is not loaded.",
      });
      return;
    }

    setIsSubmitting(true);

    const popup = new window.PaystackPop();

    popup.newTransaction({
      key: PAYSTACK_PUBLIC_KEY,
      email: "customer@email.com",
      amount: ANNUAL_AMOUNT_CENTS,
      currency: "USD",
      reference: `bcq_annual_${Date.now()}`,
      onSuccess: async (transaction) => {
        try {
          setStatus({
            type: "info",
            text: "Payment received. Verifying annual subscription...",
          });

          setStatus({
            type: "info",
            text: "Payment received. Verifying annual subscription...",
          });

          setStatus({
            type: "info",
            text: "Verifying payment. Please wait...",
          });

          await verifyPayment(transaction.reference);

          setStatus({
            type: "success",
            text: "Annual subscription activated successfully.",
          });

          window.location.href = "/dashboard";
                  } catch (error) {
          setStatus({
            type: "error",
            text: error.message || "Payment verification failed.",
          });
        } finally {
          setIsSubmitting(false);
        }
      },
      onCancel: () => {
        setIsSubmitting(false);
        setStatus({
          type: "warning",
          text: "Checkout was closed before payment completed.",
        });
      },
    });
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #020617 0%, #0b1f4b 45%, #1e3a8a 70%, #dbeafe 100%)",
        padding: "100px 24px 80px 24px",
        fontFamily: "Arial, sans-serif",
        color: "#ffffff",
      }}
    >
      <div style={{ maxWidth: "1400px", margin: "0 auto" }}>
        <div style={{ textAlign: "center", marginBottom: "28px" }}>
          <div style={{ marginBottom: "20px" }}>
            <div style={{ position: "relative", display: "inline-flex" }}>
              <div
                style={{
                  position: "absolute",
                  inset: "-14px -18px",
                  background:
                    "radial-gradient(circle, rgba(56,189,248,0.18), rgba(15,23,42,0) 70%)",
                  filter: "blur(8px)",
                }}
              />
              <img
                src="/buildcarboniq-logo.png"
                alt="BuildCarbonIQ"
                style={{
                  width: 260,
                  height: "auto",
                  position: "relative",
                  zIndex: 1,
                  filter: "drop-shadow(0 10px 24px rgba(0,0,0,0.28))",
                }}
              />
            </div>
          </div>

          <h1 style={{ margin: 0, fontSize: "56px", fontWeight: 700 }}>
            Subscription Plans
          </h1>

          <p style={{ marginTop: "8px", fontSize: "20px", color: "#dbe7ff" }}>
            Choose the plan that suits your GHG assessment needs.
          </p>
        </div>

        <div
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: "28px",
          }}
        >
          <div
            style={{
              display: "flex",
              background: "#ffffff",
              borderRadius: "999px",
              padding: "6px",
              width: "460px",
              boxShadow: "0 8px 24px rgba(0,0,0,0.18)",
            }}
          >
            <a
              href="/pricing-monthly"
              style={{
                flex: 1,
                textAlign: "center",
                padding: "14px 18px",
                borderRadius: "999px",
                textDecoration: "none",
                color: "#14223b",
                fontWeight: 600,
                background: "transparent",
              }}
            >
              Monthly
            </a>

            <a
              href="/pricing-annual"
              style={{
                flex: 1,
                textAlign: "center",
                padding: "14px 18px",
                borderRadius: "999px",
                textDecoration: "none",
                color: "#ffffff",
                fontWeight: 700,
                background: "linear-gradient(135deg, #2563eb, #38bdf8)",
              }}
            >
              Annual (Save 20%)
            </a>
          </div>
        </div>

        {status.text && (
          <div
            style={{
              maxWidth: "1180px",
              margin: "0 auto 24px auto",
              padding: "14px 18px",
              borderRadius: "12px",
              border: "1px solid",
              background:
                status.type === "success"
                  ? "#dcfce7"
                  : status.type === "warning"
                  ? "#fff7ed"
                  : status.type === "info"
                  ? "#eff6ff"
                  : "#fef2f2",
              borderColor:
                status.type === "success"
                  ? "#86efac"
                  : status.type === "warning"
                  ? "#fdba74"
                  : status.type === "info"
                  ? "#bfdbfe"
                  : "#fca5a5",
              color:
                status.type === "success"
                  ? "#166534"
                  : status.type === "warning"
                  ? "#9a3412"
                  : status.type === "info"
                  ? "#1d4ed8"
                  : "#991b1b",
              fontWeight: 700,
              textAlign: "center",
            }}
          >
            {status.text}
          </div>
        )}

        <div
          style={{
            textAlign: "center",
            marginTop: "30px",
            marginBottom: "20px",
            position: "relative",
            zIndex: 1,
            transform: "translateY(10px)",
          }}
        >
          <img
            src="/hero-dashboard.png"
            alt="BuildCarbonIQ Dashboard"
            onError={(e) => {
              e.currentTarget.style.display = "none";
            }}
            style={{
              width: "75%",
              maxWidth: "720px",
              borderRadius: "18px",
              boxShadow: "0 30px 80px rgba(0,0,0,0.35)",
              display: "block",
              margin: "0 auto",
              opacity: 0.92,
            }}
          />
        </div>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr 1fr",
            gap: "20px",
            alignItems: "center",
            marginTop: "20px",
            position: "relative",
            zIndex: 2,
            maxWidth: "1180px",
            marginLeft: "auto",
            marginRight: "auto",
          }}
        >
          <div style={cardStyle}>
            <h3 style={planTitleStyle}>FREE</h3>
            <div style={dividerStyle} />
            <h2 style={priceStyle}>
              $0 <span style={priceUnitStyle}>/year</span>
            </h2>
            <div style={dividerStyle} />
            <p style={featureStyle}>12 LCAs per year</p>
            <p style={featureStyle}>Basic dataset access</p>
            <p style={featureStyle}>Email support</p>
            <button
              type="button"
              disabled
              style={{
                ...buttonStyle,
                background: "#cbd5e1",
                color: "#475569",
                cursor: "not-allowed",
              }}
            >
              Current Starter Tier
            </button>
          </div>

          <div
            style={{
              ...cardStyle,
              transform: "translateY(-18px) scale(1.06)",
              zIndex: 2,
              boxShadow: "0 20px 50px rgba(0,0,0,0.25)",
              overflow: "hidden",
              paddingTop: 0,
            }}
          >
            <div
              style={{
                margin: "0 -36px 20px -36px",
                padding: "14px 20px",
                background: "linear-gradient(135deg, #2563eb, #38bdf8)",
                color: "#ffffff",
                fontWeight: 700,
                fontSize: "24px",
              }}
            >
              Annual (Save 20%)
            </div>

            <h3 style={{ ...planTitleStyle, fontSize: "48px", marginTop: "8px" }}>
              Pro
            </h3>

            <p
              style={{
                margin: "0 0 8px 0",
                color: "#5f6f86",
                fontSize: "14px",
                letterSpacing: "2px",
                fontWeight: 700,
              }}
            >
              MOST POPULAR
            </p>

            <div style={dividerStyle} />
            <h2 style={priceStyle}>
              ${ANNUAL_MONTHLY_EQUIVALENT_USD}
              <span style={priceUnitStyle}>/month</span>
            </h2>

            <p style={{ margin: "4px 0 4px 0", color: "#6b7280", fontStyle: "italic" }}>
              billed yearly
            </p>

            <p
              style={{
                margin: "0 0 14px 0",
                color: "#16a34a",
                fontWeight: 700,
                fontSize: "18px",
              }}
            >
              ${ANNUAL_TOTAL_USD} / year
            </p>

            <div style={dividerStyle} />
            <p style={featureStyle}>Up to 240 LCAs per year</p>
            <p style={featureStyle}>Advanced datasets</p>
            <p style={featureStyle}>Priority support</p>
            <p style={featureStyle}>CSV and XLSX exports</p>

            <button
              type="button"
              onClick={handleAnnualCheckout}
              disabled={isSubmitting}
              style={{
                ...buttonStylePrimary,
                opacity: isSubmitting ? 0.7 : 1,
              }}
            >
              {isSubmitting ? "Opening Checkout..." : "Subscribe Annually"}
            </button>
          </div>

          <div style={cardStyle}>
            <h3 style={planTitleStyle}>ENTERPRISE</h3>
            <div style={dividerStyle} />
            <h2 style={priceStyle}>Contact Us</h2>
            <div style={dividerStyle} />
            <p style={featureStyle}>Unlimited LCAs</p>
            <p style={featureStyle}>Custom datasets</p>
            <p style={featureStyle}>Dedicated support</p>
            <p style={featureStyle}>API access</p>

            <a
              href="mailto:hello@buildcarboniq.com?subject=BuildCarbonIQ%20Enterprise%20Plan"
              style={{ textDecoration: "none" }}
            >
              <button type="button" style={buttonStyleSecondary}>
                Contact Us
              </button>
            </a>
          </div>
        </div>

        <div
          style={{
            textAlign: "center",
            marginTop: "30px",
            color: "#cbd5f5",
            fontSize: "14px",
          }}
        >
          Trusted by engineers, consultants, and infrastructure teams globally
        </div>

        <div style={{ height: "60px" }} />

        <div
          style={{
            textAlign: "center",
            color: "#cbd5f5",
          }}
        >
          © BuildCarbonIQ
        </div>
      </div>
    </div>
  );
}

const cardStyle = {
  background: "#ffffff",
  border: "1px solid #dbe4f0",
  borderRadius: "18px",
  padding: "36px",
  textAlign: "center",
  color: "#14223b",
  boxShadow: "0 6px 16px rgba(0,0,0,0.08)",
  opacity: 0.97,
};

const planTitleStyle = {
  margin: "0 0 18px 0",
  fontSize: "24px",
  fontWeight: 700,
  letterSpacing: "1px",
};

const priceStyle = {
  margin: "18px 0",
  fontSize: "64px",
  fontWeight: 700,
};

const priceUnitStyle = {
  fontSize: "18px",
  fontWeight: 500,
  color: "#4b5563",
  marginLeft: "4px",
};

const featureStyle = {
  margin: "14px 0",
  fontSize: "18px",
  color: "#334155",
};

const dividerStyle = {
  height: "1px",
  background: "#e5e7eb",
  margin: "18px 0",
};

const buttonStyle = {
  marginTop: "22px",
  padding: "14px",
  width: "100%",
  borderRadius: "10px",
  border: "none",
  background: "linear-gradient(135deg, #2563eb, #3b82f6)",
  color: "#ffffff",
  cursor: "pointer",
  fontWeight: 700,
  fontSize: "16px",
};

const buttonStylePrimary = {
  marginTop: "22px",
  padding: "14px",
  width: "100%",
  borderRadius: "10px",
  border: "none",
  background: "linear-gradient(135deg, #2563eb, #3b82f6)",
  color: "#ffffff",
  cursor: "pointer",
  fontWeight: 700,
  fontSize: "16px",
};

const buttonStyleSecondary = {
  marginTop: "22px",
  padding: "14px",
  width: "100%",
  borderRadius: "10px",
  background: "#0b1f4b",
  color: "#ffffff",
  border: "1px solid #3b82f6",
  cursor: "pointer",
  fontWeight: 700,
  fontSize: "16px",
};

export default SubscriptionAnnual;